import { atom } from 'recoil'
import { IRole } from '@/pages/Users/users.types.ts'

interface IRolesAtomState {
  items: IRole[]
}

const rolesAtom = atom<IRolesAtomState>({ key: 'roles', default: { items: [] } })
export default rolesAtom
